import { metric } from '../api';
import { LANGUAGES, LANGUAGE_CODES, type LanguageCode } from '../i18n';
import { resetHistory, setLanguage, state } from '../state';
import { escapeHtml, hideModal, modalBody, show } from '../ui/modal';
import { renderHome } from '../ui/home';
import { chat } from './chat';
import { showAINotice } from './notice';

export function language(fromKiosk = false): void {
  show(
    fromKiosk ? 'Elige tu idioma · Choose your language' : 'Idiomas · Languages',
    `<div class="langgrid">${LANGUAGE_CODES.map((code) => {
      const selected = code === state.lang ? ' style="outline:3px solid #0757b8"' : '';
      return `<button data-l="${code}"${selected}>${LANGUAGES[code].flag} ${escapeHtml(LANGUAGES[code].label)}</button>`;
    }).join('')}</div>`,
  );

  for (const button of modalBody().querySelectorAll<HTMLButtonElement>('[data-l]')) {
    button.onclick = () => {
      setLanguage(button.dataset.l as LanguageCode);
      resetHistory();
      renderHome();
      void metric('language_selected');

      if (fromKiosk) {
        const next = state.startupAction === 'chat' ? () => chat() : null;
        state.startupAction = null;
        showAINotice(next);
      } else {
        hideModal();
      }
    };
  }
}
